export default __webpack_public_path__ + "static/media/964.5771609e.png";